import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useToast } from '@shared/hooks/use-toast';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CourierFileDetailApiAdapter } from '../adapters';
import { ExportPaymentsRequest } from '../models';

// Columnas por defecto para exportar
const DEFAULT_EXPORT_COLUMNS = [
    'id',
    'tracking_number',
    'original_amount',
    'effective_amount',
    'status',
    'client.name',
    'order.ref',
    'order.shop.name',
];

export const useExportPayments = () => {
    const [isExporting, setIsExporting] = useState(false);
    const { toast } = useToast();
    const { t } = useTranslation('codCourierFileDetail');

    const exportPayments = async (
        fileId: number,
        columns?: string[],
        sorting?: { column: string; direction: 'asc' | 'desc' }
    ) => {
        setIsExporting(true);
        try {
            const httpClient = createHttpClient(apiClientWH);
            const adapter = new CourierFileDetailApiAdapter(httpClient);

            const request: ExportPaymentsRequest = {
                columns: columns || DEFAULT_EXPORT_COLUMNS,
            };

            const response = await adapter.exportPayments(fileId, request, sorting);

            if (response.url_file) {
                // Abrir el archivo Excel en una nueva pestaña
                window.open(response.url_file, '_blank');

                toast({
                    title: t('export.success.title', 'Exportación exitosa'),
                    description: t('export.success.description', 'El archivo Excel se está descargando'),
                    variant: 'default',
                });
            } else {
                throw new Error(t('export.error.no_data', 'No se encontraron pagos para exportar'));
            }
        } catch (error: any) {
            const errorMessage = error?.response?.data?.error || error.message;
            toast({
                title: t('export.error.title', 'Error al exportar'),
                description: errorMessage || t('export.error.unexpected', 'Ocurrió un error inesperado'),
                variant: 'destructive',
            });
        } finally {
            setIsExporting(false);
        }
    };

    return {
        exportPayments,
        isExporting,
    };
};

